import {useQuery} from '@apollo/client';
import {BCP_CHECK_USER_GROUPS} from '../graphql/queries/bcpCheckUserGroupQueries';
import {CheckUserGroupListResponse} from '../graphql/types/BcpCheckUserGroupTypes';

export const useBcpCheckUserGroups = () => {
    const {data} = useQuery<CheckUserGroupListResponse>(BCP_CHECK_USER_GROUPS, {
        variables: {pageRequest: {page: 1, size: 999}},
    });

    return (data?.bcpCheckUserGroups?.content || [])
        .filter((g): g is typeof g & {id: number} => g.id != null)
        .map((g) => ({
            label: `${g.groupName} (ID: ${g.id})`,
            value: g.id,
        }));
};
